module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-petit.b9c42366.png";